import type { EHRProvider } from '@heidi/schema/ml-scribe';
import { atom } from 'jotai';

export const selectedProviderGroupIdsFilterAtom = atom<string[]>([]);
export const selectedDepartmentIdsFilterAtom = atom<string[]>([]);

/** True only while the Appointments tab is active. Selections intentionally outlive it. */
export const appointmentFilterSurfaceActiveAtom = atom(false);

/**
 * EHR provider the current filter selections belong to. Persists across unmount/remount
 * (unlike a component-local ref) so a provider switch made while the Appointments tab is
 * unmounted still clears stale selections the next time it mounts.
 */
export const activeFilterProviderAtom = atom<EHRProvider | undefined>(undefined);
